import { createAction, props } from "@ngrx/store";
import { Int_User } from "./mobi-office-ui.interface";

export const dummyAction = createAction("[DUMMY ACTION]");

//#region Auth State

export const GET_MOBIOFFICE_UI_User = createAction("[GET_MOBIOFFICE_UI_User] GET Logged In User");
export const GET_MOBIOFFICE_UI_User_SUCCESS = createAction("[GET_MOBIOFFICE_UI_User_SUCCESS] GOT Logged In User", props<{ payload: Int_User }>());
export const DELETE_MOBIOFFICE_UI_User = createAction("[DELETE_MOBIOFFICE_UI_User] DELETE User");

//#endregion

//#region Dynamic Table Columns

export const GET_MOBIOFFICE_UI_DynamicTableColumn = createAction("[GET_MOBIOFFICE_UI_DynamicTableColumn] Table Column Master", props<{ tableName: string }>());
export const GET_MOBIOFFICE_UI_DynamicTableColumn_SUCCESS = createAction("[GET_MOBIOFFICE_UI_DynamicTableColumn_SUCCESS] Table Column Master", props<{ payload: any }>());

//#endregion

//#region Application Details

export const GET_MOBIOFFICE_UI_ApplicationDetails = createAction("[GET_MOBIOFFICE_UI_ApplicationDetails] Application Details");
export const GET_MOBIOFFICE_UI_ApplicationDetails_SUCCESS = createAction("[GET_MOBIOFFICE_UI_ApplicationDetails_SUCCESS] Application Details", props<{ payload: any }>());

//#endregion

//#region User Applications

export const GET_MOBIOFFICE_UI_UserApplications = createAction("[GET_MOBIOFFICE_UI_UserApplications] User Applications");
export const GET_MOBIOFFICE_UI_UserApplications_SUCCESS = createAction("[GET_MOBIOFFICE_UI_UserApplications_SUCCESS] User Applications", props<{ payload: any }>());

//#endregion
